import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort, MatSortable } from "@angular/material/sort";
import { Kr998Service } from "../../services/kr998/kr998.service";
import { Kr998ErtUsersService } from "../../services/kr998ErtUsers/kr998ErtUsers.service";
import { Ikr998ErtUsers } from "../../interfaces/ert-kr998ErtUsers/ert-kr998ertusers";
import { Ikr998Data } from "../../interfaces/ert-kr998/ert-kr998Data";
import { AttendanceStatus } from "../../interfaces/ert-kr998ErtUsers/ert-kr998-attendancestatus";
import { ERTUserService } from "../../services/ert-user/ert-user.service";
import { ERTUser } from "../../interfaces/ert-user/ert-user";
import { TrainingType } from "../../services/administration/trainingtypes/trainingtypes";
import { IPicklistValuesData } from "../../interfaces/administration/picklistValuesData";
import { PicklistService } from "../../services/administration/picklist/picklist.service";
import { forkJoin } from "rxjs";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "app-ert-kr998-view",
  templateUrl: "./ert-kr998-view.component.html",
  styleUrls: ["./ert-kr998-view.component.css"],
})
export class ErtKr998ViewComponent implements OnInit {
  title = "ERT Kr998 User Details";
  totalEduItems: number;
  totalErtInstructorsItems: number;
  sortedBy: string;
  sortedEduBy: string;
  sortedErtInstructorsBy: string;
  edPageSize: 5;
  ertInstructorsPageSize: 5;
  data: any;
  krForm: FormGroup;
  validationMessages: string[] = [];
  instructors: ERTUser[] = [];
  trainingTypes = TrainingType;

  displayedUsersColumns: Map<string, string> = new Map<string, string>([
    ["kr998DetailsId", "ERT KR-998 Details: Is Instructor"],
    ["cai", "ERT KR-998 Details: CAI"],
    ["fullName", "ERT KR-998 Details: Member Name"],
    ["attendanceStatus", "ERT KR-998 Details: Attendance Status"],
    ["mgcccNumber", "ERT KR-998 Details: MGCCCC Number"],
    ["actions", "Actions"],
  ]);

  displayedInstructorsColumns: Map<string, string> = new Map<string, string>([
    ["kr998DetailsId", "ERT KR-998 Details: Is Instructor"],
    ["cai", "ERT KR-998 Details: CAI"],
    ["fullName", "ERT KR-998 Details: Member Name"],
    ["attendanceStatus", "ERT KR-998 Details: Attendance Status"],
    ["mgcccNumber", "ERT KR-998 Details: MGCCCC Number"],
    [
      "ERT_KR_998_Details_Instructor",
      "ERT KR-998 Details: Instructor at time of class",
    ],
    ["actions", "Actions"],
  ]);

  dataSource = new MatTableDataSource<Ikr998ErtUsers>();
  displayedInstructorsColumnsArray: string[] = Array.from(
    this.displayedInstructorsColumns.keys()
  );
  displayedUsersColumnsArray: string[] = Array.from(
    this.displayedUsersColumns.keys()
  );

  empErtEduDetails = new MatTableDataSource<Ikr998ErtUsers>();
  empErtInstructorsDetails = new MatTableDataSource<Ikr998ErtUsers>();

  @ViewChild("edSort") edSort!: MatSort;
  @ViewChild("edPaginator") edPaginator!: MatPaginator;
  @ViewChild("ertInstructorsSort") ertInstructorsSort!: MatSort;
  @ViewChild("ertInstructorsPaginator") ertInstructorsPaginator!: MatPaginator;
  crewFieldId: number = 0;
  categoryFieldId: number = 0;
  selectedCrew: IPicklistValuesData;
  selectedCategory: IPicklistValuesData;
  currentUser: ILoggedUserData;
  isKr998Loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private k998Service: Kr998Service,
    private userService: ERTUserService,
    private kr998ErtUserService: Kr998ErtUsersService,
    private pickListsService: PicklistService,
    private loggedUser: LoggedUserService
  ) {
    this.krForm = this.fb.group({
      id: [{ value: "", disabled: true }],
      facilityId: ["", Validators.required],
      company: ["", Validators.required],
      crew: [""],
      instructor: [""],
      category: [""],
      description: [""],
      hours: ["", Validators.required],
      location: ["", Validators.required],
      startDateTime: [""],
      endDateTime: [""],
      trainingType: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.isKr998Loading = true;
    forkJoin({
      crew: this.pickListsService.getFieldIdByName("Crew"),
      category: this.pickListsService.getFieldIdByName("Category KR998"),
    }).subscribe((results) => {
      this.crewFieldId = results.crew || 0;
      this.categoryFieldId = results.category || 0;
      this.loadRecord();
    });
    this.loggedUser.getLoggedUserData().subscribe((user) => {
      this.currentUser = user;
    });
  }

  loadRecord(): void {
    this.isKr998Loading = true;
    var facilityId: number = 0;
    const id = +this.route.snapshot.paramMap.get("id")!;
    this.loggedUser.getLoggedUserData().subscribe((user) => {
      facilityId = Number(user?.facilityId) || 1;
    });
    this.k998Service.getKr998(id, facilityId).subscribe((data) => {
      if(data.facility == null || data.facility.id !== facilityId) {
        this.isKr998Loading = false;
        this.router.navigate(["/no-access"]);
        return;
      }
      setTimeout(() => {
        this.userService
          .getUsersAndInstructors(facilityId)
          .subscribe((data) => {
            this.instructors = data.instructors.filter(
              (user) =>
                !user.picklistValues.some(
                  (picklist) => picklist.value === "Inactive"
                )
            );
        });
        this.data = data;
        this.empErtEduDetails.data = this.data.kr998ErtUsers.filter(
          (user) => !user.isInstructior && !user.instructorAtTimeOfClass
        );
        this.empErtInstructorsDetails.data = this.data.kr998ErtUsers.filter(
          (user) => user.isInstructior || user.instructorAtTimeOfClass
        );
        this.totalEduItems = this.empErtEduDetails.data.length;
        this.totalErtInstructorsItems =
          this.empErtInstructorsDetails.data.length;
        this.empErtEduDetails = new MatTableDataSource(
          this.empErtEduDetails.data
        );
        this.empErtInstructorsDetails = new MatTableDataSource(
          this.empErtInstructorsDetails.data
        );
        this.empErtEduDetails.sort = this.edSort;
        this.empErtEduDetails.paginator = this.edPaginator;
        this.empErtInstructorsDetails.sort = this.ertInstructorsSort;
        this.empErtInstructorsDetails.paginator = this.ertInstructorsPaginator;
        this.initializeForm();
      }, 10);
      this.isKr998Loading = false;
    });
  }

  initializeForm(): void {
    const selectedCrew = this.getSelectedPicklistField(this.crewFieldId);
    const selectedCategory = this.getSelectedPicklistField(
      this.categoryFieldId
    );
    this.krForm.patchValue({
      id: this.data.id,
      facilityId: this.data.facility.id,
      company: this.data.company,
      crew: selectedCrew ? selectedCrew.id : "",
      instructor:
        this.data.kr998ErtUsers && this.data.kr998ErtUsers.length > 0
          ? this.data.kr998ErtUsers[0].userErtId
          : "",
      category: selectedCategory ? selectedCategory.id : "",
      description: this.data.description,
      hours: this.data.hours,
      location: this.data.location,
      startDateTime: this.data.startDateTime.slice(0, 16),
      endDateTime: this.data.endDateTime.slice(0, 16),
      trainingType: this.data.trainingType,
    });
  }

  getSelectedPicklistField(fieldId: number) {
    let selectedPicklistValue: IPicklistValuesData =
      this.data?.picklistValues.find((x) => x.picklistFieldId === fieldId);

    return selectedPicklistValue;
  }

  onCrewSelected(crew: IPicklistValuesData): void {
    this.selectedCrew = crew;
  }

  onCategorySelected(category: IPicklistValuesData): void {
    this.selectedCategory = category;
  }

  onSubmit(): void {
    this.validationMessages = this.k998Service.validateView(this.krForm);
    if (this.validationMessages.length === 0) {
      const updatedData: Ikr998Data = {
        ...this.krForm.getRawValue(),
        id: this.data.id,
        crewId: this.selectedCrew
          ? this.selectedCrew.id
          : this.krForm.get("crew").value,
        categoryId: this.selectedCategory
          ? this.selectedCategory.id
          : this.krForm.get("category").value,
        kr998ErtUsers: [
          {
            kr998DetailsId: this.getKr998DetailsId(
              Number(this.krForm.get("instructor")?.value),
              this.data.id
            ),
            kr998Id: this.data.id,
            userErtId: Number(this.krForm.get("instructor")?.value),
            isInstructior: true,
          },
        ],
        picklistValues: [
          {
            id: this.selectedCrew
              ? this.selectedCrew.id
              : this.krForm.get("crew").value,
            value: this.selectedCrew ? this.selectedCrew.value : undefined,
            picklistFieldId: this.crewFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
          {
            id: this.selectedCategory
              ? this.selectedCategory.id
              : this.krForm.get("category").value,
            value: this.selectedCategory
              ? this.selectedCategory.value
              : undefined,
            picklistFieldId: this.categoryFieldId,
            facilityId: Number(this.currentUser?.facilityId) || 1,
          },
        ],
      };
      this.k998Service.editKr998(updatedData, Number(this.currentUser.facilityId) || 0).subscribe(() => {
        this.router.navigate(["/ert-kr998"]);
      });
    }
  }

  getKr998DetailsId(userErtId: number, kr998Id: number): any {
    return this.data.kr998ErtUsers.find(
      (user) => user.userErtId === userErtId && user.kr998Id === kr998Id
    )?.kr998DetailsId;
  }

  getAttendanceStatus(status: number): string {
    return AttendanceStatus[status] === "None"
      ? "" : AttendanceStatus[status];
  }

  getTrainingTypeKeys(): string[] {
    return Object.keys(this.trainingTypes).filter(
      (key) => !isNaN(Number(this.trainingTypes[key]))
    );
  }

  getTrainingTypeName(trainingTypeId: number): string {
    return TrainingType[trainingTypeId];
  }

  deleteRecord(id: any): void {
    if (window.confirm("Are you sure you want to delete this record?")) {
      this.kr998ErtUserService.deleteKr998ErtUsers(id).subscribe(() => {
        this.loadRecord();
      });
    }
  }

  navigateToPrint(printType: string): void {
    this.k998Service.printKR998(printType, this.data.id, Number(this.currentUser.facilityId) || 0);
  }
  getLastPostedCrew(picklistValues: IPicklistValuesData[]): string {
    let name: string = this.k998Service.getValueForField(
      picklistValues,
      this.crewFieldId
    );
    return name;
  }

  onCancel(): void {
    this.router.navigate(["/ert-kr998"]);
  }
}
